export default {
  customClick: (name) => ({
    events: {
      category: 'Clique',
      action: 'Simulador',
      label: `BTN:MonteSuaProposta:${name}`,
      noInteraction: 'false',
    },
    rule: 'customLink',
  }),

  visualization: (name) => ({
    events: {
      category: 'Alerta',
      action: 'Visualização',
      label: name,
      noInteraction: 'false',
    },
    rule: 'customLink',
  }),

  buttonClick: ({ id, text }) => {
    return {
      events: {
        id: id,
        category: 'Clique',
        action: 'Button',
        label: `BTN:${text}`,
        noInteraction: 'false',
      },
      rule: 'customLink',
    }
  },
}
